<script lang="ts">
export default {
  name: 'KkAddCard',
}
</script>

<script lang="ts" setup>
import { KkIcon } from '../'

export interface Props {
  name: string
}

export interface Emits {
  (key: 'click'): void
}

const props = defineProps<Props>()
const emits = defineEmits<Emits>()
</script>

<template>
  <button class="addCard" type="button" @click="emits('click')">
    <span class="addCard__icon"><KkIcon name="add" color="#4F4F4F" /></span>
    <span>{{ props.name }}</span>
  </button>
</template>

<style lang="scss">
@import "../../../../../stylesheets/biz_spa/foundation/_var.scss";
.addCard {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 16px;
  border: 1px solid $color-base-c;
  border-radius: 4px;
  &__icon {
    width: 16px;
    margin-right: 8px;
  }
}
</style>
